export default "__VITE_ASSET__BCzzEAR4__"